




















import TimeRangeControls from "@/components/TimeRangeControls.vue";
import { Series } from "@/types/common";
import { Component, Vue } from "vue-property-decorator";
import { State, Getter } from "vuex-class";

@Component({ components: { TimeRangeControls } })
export default class SlabStatsView extends Vue {
  created() {
    if (!this.processedStatsFetched) {
      this.$store.dispatch("debugMode/fetchProcessedSlabStatsByTimeRange");
    }
  }

  @State(state => state.debugMode.processedSlabStatsFetched)
  processedStatsFetched!: boolean;

  @Getter("debugMode/slabStatsSeries") series!: (chartID: string) => false | Series;
}
